import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import DatePicker, { registerLocale } from "react-datepicker";
import { de } from "date-fns/locale";
import { format, parse } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
// import "bootstrap/dist/css/bootstrap.min.css";

import { Link, useNavigate, useParams } from 'react-router-dom';
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import Breadcrumbs from '../components/Breadcrumbs';
import Header_3 from '../headers/Header_3';
import { Turnstile } from "@marsidev/react-turnstile";
import SEO from '../components/Seo';

// Register German locale
registerLocale("de", de);


export const FreieMietobjekteDetail = () => {

    const [selected, setSelected] = useState("tiefgarage");
    useEffect(() => {
        $(".select2").select2();
    }, []);

    let { title } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [formulare, setFormulare] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/freie-objektes?populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Metadaten]=*");

            const data = await response.json();
            console.log(data);

            if (data.data) {
                setFormulare(data.data);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    useEffect(() => {

        if (formulare?.length > 0 && title) {
            const matchedCategory = formulare?.find((category) => category.slug === title);
            // console.log(category);
            if (matchedCategory) {
                // setCategory(matchedCategory);
                setHeaderModules(matchedCategory?.Bannerbereich);
                setMetaData(matchedCategory?.Metadaten);

            } else {
                navigate("/error"); // Redirect to trigger the catch-all error route
            }
        }


    }, [formulare, title]);



    const [formData, setFormData] = useState({
        liegenschaft: "",
        parkingType: "tiefgarage",
        mietbeginn: "",
        anrede: "",
        firma: "",
        vorname: "",
        nachname: "",
        geburtsdatum: "",
        email: "",
        strasse: "",
        plz: "",
        ort: "",
        telefon: "",
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // remove warning border
        setErrors((prev) => ({
            ...prev,
            [name]: false,
        }));
    };


    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "liegenschaft",
            "parkingType",
            "mietbeginn",
            "anrede",
            "vorname",
            "nachname",
            "geburtsdatum",
            "email",
            "strasse",
            "plz",
            "ort",
            "telefon",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                newErrors[field] = true;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        $(".select2").each(function () {
            const $this = $(this);

            $this.select2();

            $this.on("change", function () {
                const name = $(this).attr("name");
                const value = $(this).val();

                console.log("Changed:", name, value);

                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");

                if (name in formData) {
                    setFormData((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }
            });
        });

        return () => {
            const selects = $(".select2");
            selects.each(function () {
                const $el = $(this);

                // destroy only if initialized
                if ($el.data("select2")) {
                    console.log("Destroying select2 for", $el.attr("name"));
                    $el.select2("destroy");
                }
            });
        };
    }, []);

    useEffect(() => {
        $(".select2").each(function () {
            const name = $(this).attr("name");

            console.log("Validating select:", name, formData[name], errors[name]);

            if (errors[name] && formData[name].trim() === "") {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .addClass("warning-border shake");
            } else {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");
            }
        });
    }, [errors]);

    const [captchaToken, setCaptchaToken] = useState("");
    const [captchaError, setCaptchaError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("Submitting form with data:", formData);
        // return;

        if (!validateForm()) {
            return;
        }

        if (!captchaToken) {
            setCaptchaError(true);
            return;
        }

        try {
            setIsSubmitting(true);

            const response = await fetch(
                `${process.env.REACT_APP_FRONTEND_URL}api/submit-freie-mietobjekte-form?pageTitle=${headerModules[0]?.Titel}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            const data = await response.json();

            console.log(data);

            if (data?.success) {
                setFormData({
                    liegenschaft: "",
                    parkingType: "tiefgarage",
                    mietbeginn: "",
                    anrede: "",
                    firma: "",
                    vorname: "",
                    nachname: "",
                    geburtsdatum: "",
                    email: "",
                    strasse: "",
                    plz: "",
                    ort: "",
                    telefon: "",
                });

                setErrors({});

                navigate("/vielen-dank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" activeInnerPage="Freie Mietobjekte" />
                        )}
                    </React.Fragment>
                ))
            )}

            <section className={`pt-pb-10 sec-orange-color`}>
                <form className="form-container" onSubmit={handleSubmit}>
                    <div className='container'>
                        <div className='sec-title'>
                            <h2 className='fs_40 fw-550 title-line-before text-darkgrey mb-4'>Ihr gewünschter Parkplatz</h2>
                        </div>
                        <div className='row'>
                            <div className='col-md-6 form-group'>
                                <h4 className='fs_26 fw-450 text-darkgrey mb-4'>Name der BGZ Liegenschaft *</h4>
                                <select
                                    className={`form-control select2`}
                                    name="liegenschaft"
                                    value={formData.liegenschaft}
                                    onChange={handleInputChange}
                                >
                                    <option value="" className="placeholder" disabled>
                                        Bitte auswählen
                                    </option>

                                    <option value="Erste Auswahl">Erste Auswahl</option>
                                    <option value="Zweite Auswahl">Zweite Auswahl</option>
                                </select>
                            </div>
                            <div className='col-md-6 form-group'>
                                <h4 className='fs_26 fw-450 text-darkgrey mb-4'>Wahl des Parkplatztyps *</h4>
                                <div className="radio-group">
                                    <label className="radio-item">
                                        <input
                                            type="radio"
                                            name="parkingType"
                                            value="tiefgarage"
                                            checked={formData.parkingType === "tiefgarage"}
                                            onChange={handleInputChange}
                                        />
                                        <span className="custom-radio"></span> Tiefgarage
                                    </label>
                                    <label className="radio-item">
                                        <input
                                            type="radio"
                                            name="parkingType"
                                            value="aussenparkplatz"
                                            checked={formData.parkingType === "aussenparkplatz"}
                                            onChange={handleInputChange}
                                        />
                                        <span className="custom-radio"></span> Aussenparkplatz
                                    </label>
                                </div>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.mietbeginn ? "warning-border shake" : ""}`}
                                    placeholder="Mietbeginn *"
                                    name="mietbeginn"
                                    value={formData.mietbeginn}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='sec-bg-grey pt-pb-10 mt-10'>
                        <div className='container'>
                            <div className='sec-title'>
                                <h2 className='fs_40 fw-550 title-line-before text-darkgrey mb-4'>Ihre persönlichen Angaben</h2>
                            </div>
                            <div className='row'>
                                <div className='col-12 form-group'>
                                    <h4 className='fs_26 fw-450 text-darkgrey'>Anrede *</h4>
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <select
                                        className={`form-control select2`}
                                        name="anrede"
                                        value={formData.anrede}
                                        onChange={handleInputChange}
                                    >
                                        <option value="" className="placeholder" disabled>
                                            Bitte auswählen
                                        </option>

                                        <option value="Frau">Frau</option>
                                        <option value="Herr">Herr</option>
                                    </select>
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Firma"
                                        name="firma"
                                        value={formData.firma}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.vorname ? "warning-border shake" : ""}`}
                                        placeholder="Vorname *"
                                        name="vorname"
                                        value={formData.vorname}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.nachname ? "warning-border shake" : ""}`}
                                        placeholder="Nachname *"
                                        name="nachname"
                                        value={formData.nachname}
                                        onChange={handleInputChange}
                                    />                                
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.strasse ? "warning-border shake" : ""}`}
                                        placeholder="Strasse *"
                                        name="strasse"
                                        value={formData.strasse}
                                        onChange={handleInputChange}
                                    />                                
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.plz ? "warning-border shake" : ""}`}
                                        placeholder="PLZ *"
                                        name="plz"
                                        value={formData.plz}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.ort ? "warning-border shake" : ""}`}
                                        placeholder="Ort *"
                                        name="ort"
                                        value={formData.ort}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.telefon ? "warning-border shake" : ""}`}
                                        placeholder="Telefon *"
                                        name="telefon"
                                        value={formData.telefon}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='col-sm-6 form-group position-relative'>
                                    {/* <input
                                        type="text"
                                        className={`form-control ${errors.geburtsdatum ? "warning-border shake" : ""}`}
                                        placeholder="Geburtsdatum *"
                                        name="geburtsdatum"
                                        value={formData.geburtsdatum}
                                        onChange={handleInputChange}
                                    /> */}
                                    <DatePicker
                                        selected={
                                            formData.geburtsdatum
                                                ? parse(formData.geburtsdatum, "dd.MM.yyyy", new Date())
                                                : null
                                        }
                                        onChange={(date) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                geburtsdatum: date
                                                    ? format(date, "dd.MM.yyyy")
                                                    : "",
                                            }));

                                            setErrors((prev) => ({
                                                ...prev,
                                                geburtsdatum: false,
                                            }));
                                        }}
                                        locale="de"
                                        dateFormat="dd.MM.yyyy"
                                        placeholderText="Geburtsdatum *"
                                        className={`form-control ${errors.geburtsdatum ? "warning-border shake" : ""
                                            }`}
                                        isClearable
                                    />
                                    {!formData.geburtsdatum && <img className='calender-icon' src="images/calender-icon-bgz2.svg" alt="" />}
                                </div>
                                <div className='col-sm-6 form-group'>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.email ? "warning-border shake" : ""}`}
                                        placeholder="E-Mail *"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className='col-sm-6 form-captcha'>
                                    <div className='col-sm-6 form-captcha'>
                                        <div className='google_recaptcha'>
                                            <Turnstile
                                                siteKey="0x4AAAAAADt5N15MzxPtrdSe"
                                                onSuccess={(token) => {
                                                    setCaptchaToken(token);
                                                    setCaptchaError(false);
                                                }}
                                                onExpire={() => {
                                                    setCaptchaToken("");
                                                }}
                                            />

                                            {captchaError && (
                                                <p
                                                    style={{
                                                        color: "red",
                                                        marginTop: "10px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    Bitte bestätigen Sie das Captcha.
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-6 form-btn mt-4 mt-sm-0'>
                                    <button
                                        type='submit'
                                        className="button round_btn btn-theme-color"
                                        disabled={isSubmitting}
                                    >
                                        {/* {isSubmitting ? "Sending..." : "Absenden"} */}
                                        absenden

                                        <span>
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                                                <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    )
}